import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#232528",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M14 2 8 8 2 2"
    }, null, -1)
  ]))]))
}
export default { render: render }